import * as React from 'react';
import { Ref, forwardRef } from 'react';
interface SVGRProps {
  color?: string;
  height?: string;
  width?: string;
  title?: string;
  titleId?: string;
}
const SvgCalendarPen = (
  { color = 'currentColor', height = '24px', width = '24px', title, titleId }: SVGRProps,
  ref: Ref<SVGSVGElement>,
): JSX.Element => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    ref={ref}
    aria-labelledby={titleId}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d="M19 4h-3V2h-2v2h-4V2H8v2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2ZM5 20V7h14V6l.002 14H5Z"
      fill={color}
    />
    <path
      d="m15.628 12.183-1.8-1.799 1.37-1.371 1.8 1.799-1.37 1.371Zm-7.623 4.018V18h1.799l4.976-4.97-1.799-1.799-4.976 4.97Z"
      fill={color}
    />
  </svg>
);
const ForwardRef = forwardRef(SvgCalendarPen);
export default ForwardRef;
